import React, { ReactNode } from 'react'
import { Box, Divider, Flex, Grid, Link, Spacer, Text } from '@ritualco/jutsu'
import { MaxWidthPage } from 'components/PageTemplates'
import { useContent, FormattedMessage } from 'lib/content/react'
interface HelpProps {
  faqLink: string
  contactPhone: string
  contactEmail: string
}

const Help = ({ faqLink, contactPhone, contactEmail }: HelpProps) => {
  const { formatMessage } = useContent()

  return (
    <Box>
      <MaxWidthPage
        heading={formatMessage({ id: 'pmportal.settings.help.title' })}
      >
        <ContactUs url={faqLink} />
        <Divider />
        <PartnerSupport email={contactEmail} phone={contactPhone} />
      </MaxWidthPage>
    </Box>
  )
}

interface ContactUsProps {
  url: string
}

const ContactUs = ({ url }: ContactUsProps) => {
  const { formatMessage } = useContent()

  return (
    <Box pt={5} pb={3}>
      <Flex direction="column" p={1}>
        <Text fontWeight="medium" fontSize="lg" pb={1}>
          {formatMessage({ id: 'pmportal.settings.help.contactUs.title' })}
        </Text>
        <Text fontWeight="medium" fontSize="small" color="grayscale.secondary">
          <FormattedMessage
            id="pmportal.settings.help.contactUs.description"
            values={{
              a: (chunks: ReactNode) => <Link href={url}>{chunks}</Link>,
            }}
          />
        </Text>
      </Flex>
    </Box>
  )
}

interface PartnerSupportProps {
  phone: string
  email: string
}

const PartnerSupport = ({ phone, email }: PartnerSupportProps) => {
  const { formatMessage } = useContent()

  return (
    <Grid templateColumns="repeat(3, 1fr)" pt={3} px={1}>
      <Text fontWeight="medium" fontSize="lg" pb={1}>
        {formatMessage({ id: 'pmportal.settings.help.contactUs.supportTitle' })}
      </Text>
      <Spacer />
      <Flex direction="column" gridGap={1}>
        <ContactDetail
          title={formatMessage({
            id: 'pmportal.settings.help.contactUs.phoneLabel',
          })}
          value={phone}
        />
        <ContactDetail
          title={formatMessage({
            id: 'pmportal.settings.help.contactUs.emailLabel',
          })}
          value={email}
        />
      </Flex>
    </Grid>
  )
}

interface ContactDetailProps {
  title: string
  value: string
}

const ContactDetail = ({ title, value }: ContactDetailProps) => {
  return (
    <Flex justify="space-between">
      <Text fontSize="small" color="grayscale.tertiary" pr={1}>
        {title}
      </Text>
      <Text fontSize="small" fontWeight="medium" color="teal.normal">
        {value}
      </Text>
    </Flex>
  )
}

export default Help
